
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/signal",
      function () {
        return require("private-next-pages/docs/signal/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/signal"])
      });
    }
  